import ArrowLeft from '@/common/assets/icons/leftPoint.svg?react';
import Button from '@/common/components/base/button/Button.tsx';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { ParticipantIncidentEntryType } from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentEntry/ParticipantIncidentEntry.type';
import { TabStateType } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantType';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Center } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const DamagedListEntry = ({
  hasDivider,
  personId,
  state,
}: ParticipantIncidentEntryType & TabStateType) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <Center
      className={css({
        borderRight: hasDivider ? '1px solid {colors.gray-2}' : '',
      })}
      height={'26px'}
      textWrap={'nowrap'}
      width={'350px'}
    >
      <Button
        fontSize={'11px'}
        gap="5px"
        fullWidth
        variant="text"
        color="primary"
        onClick={() => {
          if (state === 'image') {
            return navigate(
              ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
                id: id!,
                damagedId: personId,
              }).imagesTabPage,
            );
          } else {
            return navigate(
              ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                id: id!,
                damagedId: personId,
              }).damagedInformationTabsPage,
            );
          }
        }}
      >
        <ArrowLeft
          className={css({
            position: 'relative',
            top: '2px',
          })}
          fill={token('colors.purple-2')}
        />
        مشاهده جزئیات{' '}
      </Button>
    </Center>
  );
};
export default DamagedListEntry;
